import React, { useMemo } from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import OstorlabCredentialsForm from "./OstorlabCredentialsForm";
import OstorlabMappingForm from "./OstorlabMappingForm";

const OstorlabConfigListing = (props) => {
  const columns = useMemo(
    () => [
      {
        title: "Assets",
        dataIndex: "projectName",
        width: 130,
        render: columnRenderArrayData,
      },
    ],
    [],
  );

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={OstorlabMappingForm}
      CredentialsForm={OstorlabCredentialsForm}
      extraColumns={columns}
    />
  );
};

export default OstorlabConfigListing;